import React from "react";
import Icons from "../../../../config/images";
import "./meetTeam.css";

const MeetTeam = () => {
  const features = [
    {
      icons: Icons.teamMembers,
      title: "Same Moore",
      description: "Front End Developer",
    },
    {
      icons: Icons.teamMembers,
      title: "Same Moore",
      description: "Front End Developer",
    },
    {
      icons: Icons.teamMembers,
      title: "Same Moore",
      description: "Front End Developer",
    },
    {
      icons: Icons.teamMembers,
      title: "Same Moore",
      description: "Front End Developer",
    },
  ];

  return (
    <div className="meet-team-main-container">
      <h2>Why Choose Us?</h2>
      <span className="light-sub-text-style">The Faces Behind Our Success</span>
      <div className="meet-team-feature-grid-style">
        {" "}
        {/* Fixed class name */}
        {features?.map((feature, index) => (
          <div key={index} className="meet-team-feature-view">
            <img
              src={feature.icons}
              alt="icons"
              className="meet-team-icon-style---"
            />
            <p className="meet-team-feature-title-style">{feature.title}</p>
            <p className="meet-team-feature-description-style">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MeetTeam;
